import React from 'react';
import PropTypes from 'prop-types';

import { useExperimentsConsumer } from '@spotahome/soyuz/client';

import cityToggleConfig from '@common/config/cityToggleConfig';

import NoDepositBanner from '@search/components/NoDepositBanner';
import FreeCancellationBanner from '@search/components/FreeCancellationBanner';

const SearchBanner = ({ cityId, cancellationPolicies, moveIn }) => {
  const nsFreeCancellation = useExperimentsConsumer(
    'FreeCancellationNamespace'
  );

  if (
    cityToggleConfig(cityId).isFreeCancellationSupported &&
    nsFreeCancellation.get('behaviour') === 'variant'
  ) {
    return (
      <FreeCancellationBanner
        moveIn={moveIn}
        cancellationPolicies={cancellationPolicies}
      />
    );
  }

  if (cityToggleConfig(cityId).isNoDepositSupported) {
    return <NoDepositBanner />;
  }

  return null;
};

SearchBanner.propTypes = {
  cityId: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.shape({}),
  moveIn: PropTypes.string
};

SearchBanner.defaultProps = {
  cancellationPolicies: {},
  moveIn: null
};

export default SearchBanner;
